/**
 * Obligations Engine — Page Exports
 * 
 * Action Queue  → V2: Interactive checklist with progress tracking
 * Deadline Tracker → V2: Gantt-style timeline with calendar view
 * Obligation Register → Intent-based register mode
 * Gaps & Risks → Dedicated page with journey panels
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import ObligationsIntelligence from '../../operations/ObligationsIntelligence';

// V2 pages — distinct, dedicated components
import ActionQueuePageV2 from './ActionQueuePageV2';
import DeadlineTrackerPageV2 from './DeadlineTrackerPageV2';

// Import the actual GapsRisksPage with journey panels
export { default as GapsRisksPage } from './GapsRisksPage';

function PageShell({ children, title, subtitle }) {
  return (
    <div className="min-h-screen p-6" style={{ background: '#050a14', color: '#e2e8f0' }}>
      <div className="max-w-[1400px] mx-auto">
        <div className="mb-4">
          <h1 className="text-xl font-bold" data-testid="page-title">{title}</h1>
          {subtitle && <p className="text-sm mt-1" style={{ color: '#6b7a96' }}>{subtitle}</p>}
        </div>
        {children}
      </div>
    </div>
  );
}

// Action Queue → V2 dedicated component
export function ActionQueuePage() {
  return <ActionQueuePageV2 />;
}

// Obligation Register → Intent-based register view
export function ObligationRegisterPage() {
  const nav = useNavigate();
  return (
    <PageShell title="Obligation Register" subtitle="Complete inventory of all obligations across frameworks and entities">
      <ObligationsIntelligence
        initialMode="register"
        onNavigate={(page) => nav(`/disclosure-os`)}
      />
    </PageShell>
  );
}

// Deadline Tracker → V2 dedicated Gantt-style component
export function DeadlineTrackerPage() {
  return <DeadlineTrackerPageV2 />;
}

export default ActionQueuePage;
